<template>
    <div>
        <!-- <div class="has-background-danger">
            <div class="container">
                <div class="has-text-white has-font-serif pb-5 pt-5 t-1" v-html="texto()">
                </div>
            </div>
        </div> -->
        <div class="container">
            <nav aria-label="Breadcrumb" class="breadcrumb">
                <ol>
                    <li><a href="/" title="Página de inicio del UiKit">Inicio</a></li>
                    <li><span>Videoatención</span></li>
                </ol>
            </nav>
        </div>
    </div>
</template>

<script>
    export default {
    props: [ 'banner' ],  

    mounted(){
        // console.log(this.banner)
    },

    methods: {
      texto(){
        return `<div> ${this.banner.content} </div>`
      }
    },
    };
</script>

<style scoped>
 strong {
     color: #FFF !important;
 }
.breadcrumb a {
    align-items: center;
    color: rgb(72 95 199) !important;
}
</style>

